import styled from 'styled-components';
import { OfferStyled } from '../OfferStyled';

export const OfferStyledAP = styled(OfferStyled)`
    svg {
        g {
            circle,
            line {
                stroke: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
